<script setup lang="ts">
interface Panel {
  key: string;
  keepAlive: boolean;
}

defineProps<{
  panels: Panel[];
  active?: string;
}>();
</script>
<template>
  <div class="mp-multi-panel">
    <template v-for="item in panels" :key="item.key">
      <div v-show="item.key === active" class="mp-multi-panel__item">
        <slot :name="item.key" />
      </div>
    </template>
  </div>
</template>
<style lang="scss">
.mp-multi-panel {
  &,
  &__item {
    height: 100%;
  }
}
</style>
